import React from "react";

export const FPFooterLink = (props: React.PropsWithChildren<{
    href: string
}>): JSX.Element =>
    <a href={props.href}>
        {props.children}
    </a>
